import { PagedResult, panelGet } from "./panel.api";
import { WorkOrderRecord } from "./workOrder.api";

export interface DashboardParams {
  subsidiary?: string;
  division?: string;
  startDate?: string;
  endDate?: string;
  startAmount?: number;
  endAmount?: number;
  budget?: string;
  awardAndStrategyPaper?: string;
}

/**
 * dashboard — /dashboard (added in V3)
 *
 * These are the PANEL dashboard endpoints. The panel dashboard screen is a
 * copy of the SPA one and was still calling `/v1/spa/dashboard/...` on the SPA
 * host, which is why it rendered empty.
 */
export const dashboardApi = {
  creatorView: (params: DashboardParams = {}) => panelGet("/dashboard/creator/view", params),
  approverView: (params: DashboardParams = {}) => panelGet("/dashboard/approver/view", params),
  /** "Latest onboarded work order" table under the charts. */
  onboardedList: (params: DashboardParams & { page?: number; size?: number; status?: string; category?: string } = {}) =>
    panelGet<PagedResult<WorkOrderRecord>>("/dashboard/onboarded-list", {
      page: 0,
      size: 5,
      orderBy: "createdOn",
      ...params,
    }),
};
